import { h } from 'preact';
export const CornerDownLeft = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "9 10 4 15 9 20" }),
        h("path", { d: "M20 4v7a4 4 0 0 1-4 4H4" })));
};
//# sourceMappingURL=corner-down-left.js.map